const axios = require('axios');
const JitsiMeetJS = window.JitsiMeetJS;

export function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(window.location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g,
        " "));
}

export function getData(key, defaultValue) {
    if (!!window.localStorage && window.localStorage.getItem) {
        let _val = window.localStorage.getItem(key);
        if (!_val) {
            return defaultValue;
        }
        return _val;
    }
    return defaultValue;
}

export function setData(key, value) {
    if (!!window.localStorage && window.localStorage.setItem) {
        window.localStorage.setItem(key, value);
    }
}

export function getJson(key, defaultValue) {
    let data = getData(key, defaultValue);
    if (typeof (data) === 'string') {
        try {
            return JSON.parse(data);
        } catch (ignored) { }
    }
    return defaultValue;
}

export function getVideoInputs() {
    return new Promise((resolve) => {
        if (JitsiMeetJS.mediaDevices.isDeviceChangeAvailable('output')) {
            JitsiMeetJS.mediaDevices.enumerateDevices((devices) => {
                const videoInputDevices = devices.filter(d => d.kind === 'videoinput');
                // const audioOutputDevices = devices.filter(d => d.kind === 'audiooutput');
                if (videoInputDevices.length > 1) {
                    // VIDEO FILTER
                    let videoInputs = [];

                    for (let i = 0; i < videoInputDevices.length; i++) {
                        const d = videoInputDevices[i];
                        videoInputs.push({
                            value: d.deviceId,
                            label: d.label
                        });
                    }
                    return resolve(videoInputs);
                }
                // if (audioOutputDevices.length > 1) {
                // AUDIO FILTER
                // setInputAudioOptions(videoInputs);
                // }
            });
        } else {
            resolve([]);
        }
    });
}

window.utils = {
    getParameterByName,
    getJson,
    getData,
    setData,
    getVideoInputs,
}